class LqdAnimatedFrame extends elementorModules.frontend.handlers.Base {

  onInit(...args) {

    super.onInit(...args);

    this.handleDestroy();

    this.initSplitText();
    this.initAnimateFrame();

  }

  getDefaultSettings() {
    return {
      selectors: {
        splitTextElement: '[data-split-text]',
        animatedFrameElement: '[data-liquid-animatedframes=true]',
      }
    }
  }

  getDefaultElements() {
    const selectors = this.getSettings('selectors');
    return {
      $splitTextElement: this.$element.find(selectors.splitTextElement),
      $animatedFrameElement: this.$element.find(selectors.animatedFrameElement),
    }
  }

  initSplitText() {

    this.elements.$splitTextElement.liquidSplitText();

  }

  initAnimateFrame() {

    this.elements.$animatedFrameElement.liquidAnimatedFrames();

  }

  onDestroy() {

    this.handleDestroy();

    super.onDestroy();

  }

  handleDestroy() {

    this.handleSplitTextDestroy();
    this.handleAnimatedFrameDestroy();

  }

  handleSplitTextDestroy() {

    if ( ! this.elements.$splitTextElement.length ) return;

    const splitTextData = this.elements.$splitTextElement.data('plugin_liquidSplitText');

    if ( splitTextData ) {
      splitTextData.destroy();
    }

  }

  handleAnimatedFrameDestroy() {

    if ( ! this.elements.$animatedFrameElement.length ) return;

    const animatedFramesData = this.elements.$animatedFrameElement.data('plugin_liquidAnimatedFrames');

    if ( animatedFramesData ) {
      animatedFramesData.destroy();
    }

  }
  
}

export default ($element) => {
  elementorFrontend.elementsHandler.addHandler( LqdAnimatedFrame, { $element } );
};